import clsx from 'clsx'
import type { JSX } from 'react'

type TypographyProps = {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'small'
  as?: keyof JSX.IntrinsicElements
  className?: string
  children: React.ReactNode
  id?: string
}

const Typography: React.FC<TypographyProps> = ({ variant = 'p', as, className, children, id }) => {
  const Component = as || variant

  const styles = {
    h1: 'text-xl sm:text-2xl md:text-3xl font-bold', // Mobile-first: menor no mobile
    h2: 'text-lg sm:text-xl md:text-2xl font-semibold',
    h3: 'text-base sm:text-lg md:text-xl font-medium',
    h4: 'text-sm sm:text-base md:text-lg font-medium',
    h5: 'text-xs sm:text-sm md:text-base font-medium',
    h6: 'text-xs sm:text-sm font-medium',
    p: 'text-xs sm:text-sm', // Mobile-first: texto menor
    span: 'text-xs sm:text-sm',
    small: 'text-[10px] sm:text-xs', // Mobile-first: ainda menor
  }

  return (
    <Component className={clsx(styles[variant], className)} id={id}>
      {children}
    </Component>
  )
}

export default Typography
